import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class TestSupport {
  static isGeminiVREnvironment() {
    try {
      for (const k in global) {
        if (k.startsWith('__gemini_') && k.endsWith('__')) {
          return true;
        }
      }
    } catch (e) {
      // ignore
    }
    return false;
  }
  static areMetadataCallsDisabled() {
    return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty(TestSupport.DISABLE_METADATA_CALLS_PROPERTY);
  }
  static areEventCallsDisabled() {
    return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty(TestSupport.DISABLE_EVENT_CALLS_PROPERTY);
  }
  static areFetchCallsDisabled() {
    return this.getGlobalBooleanProperty(TestSupport.DISABLE_FETCH_CALLS_PROPERTY);
  }
  static getSyntheticFlagOverride() {
    return this.getGlobalTriStateProperty(TestSupport.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
  }
  static getGlobalBooleanProperty(propertyName) {
    if (global && global.hasOwnProperty(propertyName)) {
      return global[propertyName] === true;
    }
    return false;
  }
  static getGlobalTriStateProperty(propertyName) {
    if (global && global.hasOwnProperty(propertyName)) {
      const value = global[propertyName];
      if (typeof value === 'boolean') {
        return value;
      }
    }
    return undefined;
  }
}
_defineProperty(TestSupport, "DISABLE_METADATA_CALLS_PROPERTY", '__awc_disable_metadata_calls__');
_defineProperty(TestSupport, "DISABLE_EVENT_CALLS_PROPERTY", '__awc_disable_event_calls__');
_defineProperty(TestSupport, "DISABLE_FETCH_CALLS_PROPERTY", '__awc_disable_fetch_calls__');
_defineProperty(TestSupport, "SYNTHETIC_FLAG_OVERRIDE_PROPERTY", '__awc_synthetic_flag_override__');